
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.024 2.84c-.128 0-.208-.005-.24-.016-.021-.01-.048-.053-.08-.128 0-.043.085-.464.256-1.264.181-.81.283-1.232.304-1.264 0-.043.021-.064.064-.064.021-.021.507-.032 1.456-.032h1.424c.043.043.08.075.112.096l-.016.288c0 .427-.059.87-.176 1.328-.107.448-.32 1.147-.64 2.096-.437 1.216-.699 2.187-.784 2.912-.01.085-.016.283-.016.592 0 1.003.283 1.819.848 2.448.565.619 1.312.928 2.24.928.427 0 .848-.09 1.264-.272 1.216-.533 1.824-1.568 1.824-3.104 0-.224-.01-.421-.032-.592-.085-.725-.347-1.696-.784-2.912-.384-1.11-.624-1.925-.72-2.448A6.203 6.203 0 017.216.36c0-.107.005-.17.016-.192.032-.053.101-.08.208-.08.117-.01.56-.016 1.328-.016h1.424a.435.435 0 01.096.112c.01.01.101.427.272 1.248.181.81.272 1.232.272 1.264-.032.075-.064.117-.096.128a.811.811 0 01-.224.016c-.139 0-.224-.01-.256-.032-.032-.032-.085-.208-.16-.528a4.59 4.59 0 00-.224-.816c-.021-.032-.117-.08-.288-.144-.128-.021-.507-.032-1.136-.032-.32 0-.48.005-.48.016 0 .064.053.213.16.448.16.448.523 1.104 1.088 1.968.683 1.099 1.11 1.936 1.28 2.512.107.395.16.763.16 1.104 0 .31-.043.608-.128.896-.192.704-.592 1.328-1.2 1.872-.981.832-2.165 1.248-3.552 1.248-1.397 0-2.587-.416-3.568-1.248C1.6 9.56 1.2 8.936 1.008 8.232a3.137 3.137 0 01-.128-.896c0-.341.053-.71.16-1.104.17-.576.597-1.413 1.28-2.512.565-.864.928-1.52 1.088-1.968.107-.235.16-.384.16-.448 0-.01-.16-.016-.48-.016H2.72a5.899 5.899 0 00-.352-.016c-.405 0-.64.064-.704.192a4.59 4.59 0 00-.224.816c-.075.32-.128.496-.16.528-.032.021-.117.032-.256.032z","fill":"currentColor"}})])
          )
        }
      }
    